const options = {
  5: "bg-yellow-100/5",
  10: "bg-yellow-100/10",
  25: "bg-yellow-100/25",
  50: "bg-yellow-100/50",
  75: "bg-yellow-100/75",
  90: "bg-yellow-100/90",
  100: "bg-yellow-100",
};

const from = {
  5: "from-yellow-100/5",
  10: "from-yellow-100/10",
  25: "from-yellow-100/25",
  50: "from-yellow-100/50",
  75: "from-yellow-100/75",
  90: "from-yellow-100/90",
  100: "from-yellow-100",
};

export default function getBackgroundYellow100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
